import { CalendarState, RangeCalendarState } from 'react-stately';

const isRangeCalendarContext = (
    state: CalendarState | RangeCalendarState
): state is RangeCalendarState => 'anchorDate' in state;

export default isRangeCalendarContext;
